(function() {

    const c24 = window.c24;

    c24.lp.ctaTracker = {

        init: function() {
            window.c24DomReady(function() {

                const forms = document.querySelectorAll('.mod24ac form');
                for (const form of forms) {
                    form.addEventListener('submit', function() {

                        let name = 'main';
                        const ctaObjContainer = this.closest('.mod24ac');
                        const trackingArray = [
                            'trackEvent',
                            window.c24Lp.getMatomoEventCategory(),
                            'cta:compare',
                        ];

                        if (ctaObjContainer.classList.contains('mini')) {
                            name = 'mini';
                            trackingArray.push('cta:' + name);
                            window._paq.push(trackingArray);
                            return;
                        }

                        let isFixableObj = ctaObjContainer.querySelector('.js24Fixable').classList.contains('js24Fixed');

                        if (isFixableObj) {
                            const percentageValue = window.c24.lp.ctaTracker.calcPosition();
                            name = 'sticky';
                            trackingArray.push('value:' + percentageValue);
                        }
                        trackingArray.push('cta:' + name);
                        window._paq.push(trackingArray);
                    });
                }
            });
        },
        calcPosition: function() {
            const currentPosition = window.scrollY;
            const windowHeight = window.innerHeight;
            const totalHeight = document.documentElement.scrollHeight;
            const scrollPercentage = (currentPosition / (totalHeight - windowHeight)) * 100;
            let percentageValue = null;

            if (scrollPercentage <= 25) {
                percentageValue = 0.25;
            } else if (scrollPercentage <= 50) {
                percentageValue = 0.5;
            } else if (scrollPercentage <= 75) {
                percentageValue = 0.75;
            } else if (scrollPercentage < 100) {
                percentageValue = 0.99;
            } else {
                percentageValue = 1;
            }

            return percentageValue;
        },
    };
})();

window.c24.lp.ctaTracker.init();
